import { lt } from '@mews/framework';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { ConvertedCurrencyValue } from '@mews-commander/ui';
import { PaymentLinkDetailItem } from './PaymentLinkDetailItem';

export const PaymentAmountInfoRow = ({ paymentId, accountId }: { paymentId: string; accountId: string }) => {
    const { data: payment } = useRepositorySuspenseQuery(
        'payments',
        'getAll',
        { ids: [paymentId], accountId },
        { select: (data) => data.payments[0] }
    );

    return (
        <PaymentLinkDetailItem
            description={lt('GeneralAmountPrice')}
            value={<ConvertedCurrencyValue amount={payment?.value} />}
        />
    );
};
